import React, { Component, ReactNode } from "react"
import Offline from "./pages/offline"

type ErrorBoundaryProps = { children: ReactNode; fallback?: (error: Error, errorInfo: React.ErrorInfo) => ReactNode }

type ErrorBoundaryState = { hasError: boolean; error?: Error; errorInfo?: React.ErrorInfo }

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    // React 19 provides more detailed error information
    console.error("Error caught in ErrorBoundary:", error, errorInfo)

    // Store error info for better debugging in React 19
    this.setState({ errorInfo })

    // You can also report to error tracking service here
    // reportError(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // Use custom fallback if provided, otherwise use default
      if (this.props.fallback && this.state.error && this.state.errorInfo) {
        return this.props.fallback(this.state.error, this.state.errorInfo)
      }

      return <Offline retry={() => this.setState({ hasError: false, error: undefined, errorInfo: undefined })} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
